import posthog from 'posthog-js';
import config from './posthog-config.json';

let initialized = false;
export function analyticsAllowed(location = window.location, userAgent = navigator.userAgent) {
  const params = new URLSearchParams(location.search);
  let pathname;
  try { pathname = decodeURIComponent(location.pathname); } catch { return false; }
  return location.hostname === 'www.first1000.co'
    && !/^\/(verify|verified|welcome)(\/|$)/i.test(pathname)
    && !['lazyweb_preview', 'agent_metrics_preview'].some(key => params.has(key))
    && (!params.has('lazyweb_test_run') || Boolean(params.get('posthog_test_run')))
    && userAgent !== 'ReactSnap';
}
export function initAnalytics() {
  if (initialized || !analyticsAllowed()) return;
  try { posthog.init(config.token, {
    api_host: config.apiHost,
    ui_host: config.uiHost,
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
    autocapture: true,
    capture_pageview: 'history_change',
    disable_session_recording: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
    before_send: event => {
      if (!analyticsAllowed()) return null;
      const runId = new URLSearchParams(window.location.search).get('posthog_test_run');
      if (runId) event.properties.test_run_id = runId.slice(0, 100);
      return event;
    },
    loaded: instance => {
      if (new URLSearchParams(window.location.search).has('posthog_test_run')) instance.setInternalOrTestUser();
    },
  });
  initialized = true; } catch { /* Analytics must not block the website. */ }
}
export function capture(event, properties) {
  if (!initialized || !analyticsAllowed()) return;
  try { posthog.capture(event, properties); } catch { /* Analytics must not change form outcomes. */ }
}
